import { TReduxActions } from '../../types/redux';
import { IExperiment } from '../../types/experiments';

const defaultState: IExperiment[] = [];

export function experimentsReducer(state: IExperiment[] = defaultState, action: TReduxActions): IExperiment[] {
  return state;
}
